// Define custom styles for react-select
export const customStyles = {
                control: (provided, state) => ({
                  ...provided,
                  minWidth: '196.5px',
                  width: '100%',
                  minHeight: '30px',
                  fontSize: '12px',
                  borderColor: state.isFocused ? 'rgba(38, 132, 255)' : '#ababab',
                  boxShadow: state.isFocused ? '0 0 0 2px rgba(38, 132, 255)' : '',
                  cursor: 'pointer'
                }),
                option: provided => ({
                  ...provided,
                  fontSize: '12px',
                  padding: '10px',
                  cursor: 'pointer'
                }),
                multiValue: provided => ({
                  ...provided,
                  backgroundColor: '#8122b4',
                  color: '#fff'
                }),
                multiValueLabel: provided => ({
                  ...provided,
                  color: '#fff',
                  fontSize: '12px'
                }),
                multiValueRemove: provided => ({
                  ...provided,
                  color: '#fff',
                  ':hover': {
                    backgroundColor: '#f06262',
                    color: '#fff'
                  }
                }),
                placeholder: provided => ({
                  ...provided,
                  fontSize: '12px',
                  color: '#ababab'
                }),
                singleValue: provided => ({
                  ...provided,
                  fontSize: '12px'
                }),
                input: provided => ({
                  ...provided,
                  fontSize: '12px',
                  margin: '0px',
                  padding: '0px'
                }),
                dropdownIndicator: (provided, state) => ({
                  ...provided,
                  padding: '0px',
                  marginLeft: '5px',
                  marginRight: '5px',
                  opacity: state.isFocused ? '0.2' : '1'
                }),
                clearIndicator: provided => ({
                  ...provided,
                  padding: '0px',
                  marginLeft: '2.5px',
                  marginRight: '2.5px'
                })
              }